const AUTH_ONLY_PATHS = new Set([
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
]);

function normalizeReturnTo(from) {
  let target;
  if (typeof from === "string") {
    try {
      const parsed = new URL(from, "https://nrsapp.internal");
      if (parsed.origin !== "https://nrsapp.internal") return null;
      target = {
        pathname: parsed.pathname,
        search: parsed.search,
        hash: parsed.hash,
      };
    } catch {
      return null;
    }
  } else if (from && typeof from === "object") {
    target = from;
  } else {
    return null;
  }

  const { pathname, search = "", hash = "" } = target;
  if (
    typeof pathname !== "string"
    || !pathname.startsWith("/")
    || pathname.startsWith("//")
    || pathname.includes("\\")
    || AUTH_ONLY_PATHS.has(pathname)
  ) {
    return null;
  }

  return {
    pathname,
    search: typeof search === "string" && search.startsWith("?") ? search : "",
    hash: typeof hash === "string" && hash.startsWith("#") ? hash : "",
  };
}

export function getPostAuthTarget(account, from) {
  if (
    account?.account_tier === "demo"
    && account?.role !== "admin"
    && account?.workspace_role !== "viewer"
  ) {
    return "/demo/classification";
  }

  return normalizeReturnTo(from) || "/dashboard";
}
